"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

require("./HomepageBannerItems.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var HomepageBannerItems = function HomepageBannerItems(props) {
  var image = props.image,
      firstText = props.firstText,
      yellowText = props.yellowText,
      secondText = props.secondText;
  return _react.default.createElement("div", {
    className: "col33"
  }, _react.default.createElement("img", {
    className: "small-icon",
    src: image,
    alt: "tyre icon",
    "data-aos": "fade-up",
    "data-aos-easing": "ease-out-back",
    "data-aos-duration": "1000",
    "data-aos-delay": "0"
  }), _react.default.createElement("h3", null, firstText, _react.default.createElement("span", null, " ", yellowText), " ", secondText));
};

HomepageBannerItems.defaultProps = {
  image: "",
  firstText: "",
  yellowText: "",
  secondText: ""
};
var _default = HomepageBannerItems;
exports.default = _default;